<template>
    <v-card>
        <s-toolbar label="Lista de Inducción de Personal" dark color="#8e8f91"></s-toolbar>
        <v-container>
            <v-row>
                <v-col cols="12" md="4">
                    <s-toolbar-person noCamera label="Documento*" noEdit v-model="PrsDocumentNumber" @returnPerson="getData($event)" />
                </v-col>
                <v-col cols="12" md="8">
                    <s-text readonly label="Persona" v-model="NtpFullName"></s-text>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-data-table
                        :headers="headers"
                        :items="itemsInduction"
                        dense
                    >
                        <template v-slot:[`item.InsDate`]="{ item }">
                            {{ $fun.formatDateView(item.InsDate) }}
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>
<script>
import _sInstructionAttendance from "@/services/Management/InstructionAttendanceService";
import sToolbarPerson from "@/components/Utils/Person/sToolbarPerson";

export default {
    name: 'InstructionListView',
    components: { sToolbarPerson },
    data() {
        return {
            PrsDocumentNumber: null,
            NtpFullName: null,
            itemsInduction: [],
            headers: [
                { text: 'ID', value: 'IasID' },
                { text: 'Nombre y Apellido', value: 'NtpFullName' },
                { text: 'Fecha', value: 'InsDate' },
                { text: 'Hora Inicio', value: 'IInicioTime' },
                { text: 'Hora Fin', value: 'IFinTime' },
                { text: 'Capacitador', value: 'IinNamePerson' },
                { text: 'Tema', value: 'IsbSubject' },
                { text: 'Descripcion', value: 'IsbDescription' },
            ]
        }
    },
    methods: {
        async getData(item){
            console.log(item);
            if(item != null){
                this.PrsDocumentNumber = item.PrsDocumentNumber;
                this.NtpFullName = item.NtpFullName;
            }

            if(this.PrsDocumentNumber != null){
                await _sInstructionAttendance.paginationInducction(this.PrsDocumentNumber, 2, this.$fun.getUserID()).then(resp => {
                this.itemsInduction = [];
                if(resp.status == 200)
                {
                    console.log('resp.data:', resp.data);
                    this.itemsInduction = resp.data;
                }
                })
            }
        }
    }    
}
</script>